import { render, staticRenderFns } from "./SM.vue?vue&type=template&id=24fb34d7&"
import script from "./SM.vue?vue&type=script&lang=js&"
export * from "./SM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports